export default __webpack_public_path__ + "static/media/pp-19-bizon.52ebddc3.svg";